import * as classnames from 'classnames'
import * as React from 'react'

import 'rheostat/initialize'

import Rheostat from 'rheostat'

import * as styles from './volumeSlider.module.css'

interface IProps {
  muted: boolean
  volumeLevel: number
  setVolumeLevel: (level: number) => any
  onMute: () => any
  onUnmute: () => any
}

interface IState {
  sliderLevel: number
}

interface ISliderChangePayload {
  values: number[]
}

interface ISliderValues {
  volumeLevel: number
  muted: boolean
}

interface IHandleProps {
  handleRef: string
}

const handle = ({ handleRef, ...passProps }: IHandleProps) => (
  <button
    type="button"
    ref={handleRef}
    aria-label={'volume slider'}
    {...passProps}
    className="volumeHandle"
  />
)

class VolumeSlider extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
  }

  public render() {
    const { volumeLevel, muted } = this.props
    const rootClassNames = classnames(styles.root, {
      [styles.optionHandleGrey]: muted,
      [styles.optionHandleGreen]: !muted
    })
    return (
      <div className={rootClassNames}>
        <Rheostat
          values={[this.getSliderValue(this.props)]}
          max={100}
          onValuesUpdated={this.handleChange}
          handle={handle}
        />
      </div>
    )
  }

  private handleChange = ({ values: [level] }: ISliderChangePayload) => {
    const { setVolumeLevel, onMute, onUnmute } = this.props
    setVolumeLevel(level)
    if (level === 0) {
      onMute()
    } else {
      onUnmute()
    }
  }

  private getSliderValue = ({ volumeLevel, muted }: ISliderValues) => {
    if (muted) {
      return 0
    }
    return volumeLevel
  }
}

export default VolumeSlider
